import * as React from 'react';
import { memo } from 'react';

import Icon from 'components/atoms/Icon';

const css = (done?: boolean, modifier?: string): string => {
	const classes = [
		'a-icon-todo',
		modifier ? `a-icon-todo--${modifier}` : '',
		done ? 'state-a-icon-todo--completed' : '',
	];

	return classes.filter(Boolean).join(' ');
};

export type IconTodoProps = {
	done: boolean;
	type?: string;
	icon: string;
};

export const IconTodo = ({ type, icon, done }: IconTodoProps) => (
	<div className={css(done, type)}>
		<div className="a-icon-todo__category">
			<div className="a-icon-todo__category-icon">
				<Icon iconName={icon} />
			</div>
		</div>
		<div className="a-icon-todo__status">
			<div className="a-icon-todo__status-icon">
				{done ? <Icon iconName="completed" /> : <Icon iconName="link-arrow" />}
			</div>
		</div>
	</div>
);

IconTodo.displayName = 'IconTodo';

export default memo(IconTodo, (prevProps, nextProps) => {
	return prevProps.type === nextProps.type && prevProps.done === nextProps.done && prevProps.icon === nextProps.icon;
});
